// extracted by mini-css-extract-plugin
module.exports = {"angel":"AngelCard_angel__1sGkt","job":"AngelCard_job__xamjP","text":"AngelCard_text__2vdO4","sending":"AngelCard_sending__3z8LK"};